if (!customElements.get('frame-finder-main')) {
    class FrameFinderMain extends HTMLElement {
        constructor() {
            super();
            this.index = parseInt(this.dataset.index);
            this.type = this.dataset.type;
            localStorage.setItem(FRAME_FINDER_KEYS.localStorageKey, JSON.stringify([]));
            localStorage.setItem(FRAME_FINDER_KEYS.firstQuestionKey, JSON.stringify(''));

            this.noResultsText = this.querySelector('#no-results-text');

            this.isProductFound = localStorage.getItem('is-product-found');

        }

        connectedCallback() {


            if (CookieUtils.getCookie(FRAME_FINDER_KEYS.filteredUrlKey)) {
                this.initializeFrameFinder(this.type, false);
            } else {
                this.initializeFrameFinder(null, true);
            }
            if (this.isProductFound == 'false') {
                this.noResultsText.setAttribute('aria-hidden', false);
            }

            this.initializeButtons();
        }


        /**
         * Add an event listener on each answer option change, then enable/disable the button based on it
         * @param {HTMLElement} nextButton 
         */
        addOptionChangeListeners(nextButton) {
            const allOptions = this.querySelectorAll('input[type="radio"], input[type="checkbox"]');
            allOptions.forEach(option => {
                option.addEventListener('change', () => {
                    const selectedOptions = this.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
                    nextButton.disabled = selectedOptions.length === 0; // Disabilita il pulsante se non ci sono selezioni
                });
            });
        }


        /**
         * Initialize the frame finder based on the cookie value
         * @param {string} type wheter to show frame finder questions or results
         * @param {boolean} showQuestions wheter to show questions or not
         */
        initializeFrameFinder(type = null, showQuestions = true) {
            if (type == "results" && showQuestions == false) {
                this.style.display = 'block';
                return;
            }
            showQuestions && this.initQuestions();
        }


        /**
         * Handle the click of the prev-button: navigate to the previous question and remove the current
         * answer from answer history
         */
        handlePrev() {
            this.navigateToQuestion(false);
            this.removeCurrentAnswer();
        }


        /**
         * Handle the click of the next-button: update the answers with the new values and navigate
         * to the next question
         */
        handleNext() {
            this.setNewAnswerValues();
            this.navigateToQuestion();
        }


        /**
         * Given the previous/next question coordinates, show it and hide the current one
         * @param {string} questionCoordinates 
         */
        showQuestion(questionCoordinates) {
            const questionBlock = FrameFinderUtils.getQuestionFromCoordinates(questionCoordinates);

            this.classList.remove('active');
            this.style.display = 'none';

            if (questionBlock) {
                FrameFinderUtils.checkNextButtonState(questionBlock);
                this.checkQuestionContainerMaxWidth(questionBlock);
                questionBlock.classList.add('active');
                questionBlock.style.display = 'block';
            }
        }


        /**
         * Given a question container, check the number of visible answer options, 
         * if it's more than 4 set the max width to x px
         * 
         * NB: this is only for the questions with radio answers
         * @param {HTMLElement} questionBlock the question block to check
         */
        checkQuestionContainerMaxWidth(questionBlock) {
            let visibleAnswersCount = 0;
            let rbQuestionContainer = questionBlock.querySelector('.question-container-rb');
            if (!rbQuestionContainer) {
                return;
            }
            let radioAnswers = rbQuestionContainer.children;

            for (let ans of radioAnswers) {
                let option = ans.querySelector('.ff-answer-option');
                if (option.style.display != 'none') {
                    visibleAnswersCount++;
                }
            }

            rbQuestionContainer.style.maxWidth = visibleAnswersCount > 4 ? '770px' : 'none';
        }


        /**
         * Retrieves the selected values for the current question: filter names, filter values and next question coordinates.
         * These values are then paired to the FRAME_FINDER_ANSWER_KEYS to create the return object.
         * @returns {Object} Returns an object with the following key-values: filter name, filter value, coordinates and next question coordinates
         */
        getAnwerValues() {
            const currentCoordinates = this.getCoordinatesFromQuestion();
            const selectedOptions = this.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
            if (selectedOptions.length === 0) {
                return;
            }

            let filterNames = [];
            let filterValues = [];
            let nextCoordinates = '';

            selectedOptions.forEach(option => {
                const [filterName, filterValue, nextQuestionCoordinates] = this.getOptionValues(option);

                if (filterName) {
                    filterName.split(';;').forEach((fName) => {
                        filterNames.push(fName);
                    })
                } else {
                    filterNames.push('')
                }

                filterValue.split(';;').forEach((fValue) => {
                    filterValues.push(fValue);
                });

                nextCoordinates = nextQuestionCoordinates;
            });

            const answerValues = {
                [FRAME_FINDER_ANSWER_KEYS.filterName]: filterNames,
                [FRAME_FINDER_ANSWER_KEYS.filterValue]: filterValues,
                [FRAME_FINDER_ANSWER_KEYS.coordinates]: currentCoordinates,
                [FRAME_FINDER_ANSWER_KEYS.nextCoordinates]: nextCoordinates
            };

            return answerValues;
        }


        /**
         * Display the get started block, set the question index for the first question and disable its prev-button
         */
        initQuestions() {
            let getStartedBlock = this.closest('#frame-finder-get-started');

            if (getStartedBlock) {
                getStartedBlock.classList.add('active');
                getStartedBlock.style.display = 'block';

                getStartedBlock.querySelector('.frame-finder-start-button').addEventListener('click', (evt) => {
                    const firstFlow = this.closest('#MainContent').querySelectorAll('.frame-finder-flow')[0];
                    let firstQuestion = firstFlow.querySelectorAll('frame-finder-main')[0];

                    if (!firstQuestion) {
                        return;
                    }

                    firstQuestion.querySelector('.prev-button').disabled = true;
                    firstQuestion.querySelector('.frame-finder-question-indicator').textContent = "QUESTION 1";
                });
            }
        }


        /**
         * Updated the current answer history array in localStorage with the new answers
         */
        setNewAnswerValues() {
            const answersHistory = JSON.parse(localStorage.getItem(FRAME_FINDER_KEYS.localStorageKey)) || [];

            const returnValues = this.getAnwerValues();
            answersHistory.push(returnValues);

            if (answersHistory.length == 1) {
                localStorage.setItem(FRAME_FINDER_KEYS.firstQuestionKey, JSON.stringify(returnValues));
            }

            localStorage.setItem(FRAME_FINDER_KEYS.localStorageKey, JSON.stringify(answersHistory));
        }


        /**
         * Given and answer option, retrieve its answer value, filter name and next question coordinates
         * @param {HTMLElement} option 
         * @returns {string[]}
         */
        getOptionValues(option) {
            const answerValue = option.value;
            const filterName = option.getAttribute('data-url');
            const nextQuestionCoordinates = option.getAttribute('next-question');

            return [filterName, answerValue, nextQuestionCoordinates];
        }


        /**
         * Get the coordinates of the current question
         * @returns {string} Returns the coordinates like flowId-questionIndex, ex: start-1
         */
        getCoordinatesFromQuestion() {
            const questionIndex = this.id.split('frame-finder-question-')[1];
            if (!questionIndex) {
                return
            }
            const currentQuestionFlow = this.closest(".frame-finder-flow");
            const currentFlowId = currentQuestionFlow.id.split('frame-finder-flow-')[1];

            return `${currentFlowId}-${questionIndex}`;
        }


        /**
         * Removes the last answer from the localStorage answer history
         */
        removeCurrentAnswer() {
            let answerHistory = JSON.parse(localStorage.getItem(FRAME_FINDER_KEYS.localStorageKey)) || [];
            answerHistory.pop();

            localStorage.setItem(FRAME_FINDER_KEYS.localStorageKey, JSON.stringify(answerHistory));
        }


        /**
         * Get the prev and next buttons from the current question block, 
         * add the handlePrev, handleNext and addOptionChangeListener functions 
         * and disable the next buttons
         */
        initializeButtons() {
            const nextButtons = this.querySelectorAll('.next-button');
            const prevButtons = this.querySelectorAll('.prev-button');
            const closeAlertButtons = this.querySelectorAll('#ff-alert-close-btn');
            const skipButtons = this.querySelectorAll('#frame-finder-skip-btn');
            const lastStepButtons = this.querySelectorAll('#ff-last-step-btn');
            const noPrefButtons = this.querySelectorAll('input.no-prefinput');

            if (nextButtons.length > 0) {
                nextButtons.forEach(nextButton => {
                    nextButton.disabled = true;

                    this.addOptionChangeListeners(nextButton);
                    nextButton.addEventListener('click', () => this.handleNext());
                });
            }

            if (prevButtons.length > 0) {
                prevButtons.forEach(
                    prevButton => prevButton.addEventListener('click', () => this.handlePrev())
                );
            }

            if (closeAlertButtons.length > 0) {
                closeAlertButtons.forEach(
                    closeButton => closeButton.addEventListener('click', () => this.handleAlertClose())
                );
            }
            if (skipButtons.length > 0) {
                skipButtons.forEach(
                    skipButton => skipButton.addEventListener('click', () => this.handleSkip())
                );
            }
            if (lastStepButtons.length > 0) {
                lastStepButtons.forEach(btn => {
                    btn.addEventListener('click', () => this.handleLastStep(btn.dataset.lastStep))
                })
            }

            if (noPrefButtons.length > 0) {
                noPrefButtons.forEach(btn => {
                    btn.addEventListener('click', () => this.handleNoPreference())
                })
            }
        }


        /**
         * If the isQuestionNext parameter is true, then navigate to the next question and set its question index indicator
         * else navigate to the previous one
         * @param {boolean} isQuestionNext whether the question to display is next or previous to the current one
         */
        navigateToQuestion(isQuestionNext = true) {
            const answerHistory = JSON.parse(localStorage.getItem(FRAME_FINDER_KEYS.localStorageKey)) || [];
            const questionCoordinates = answerHistory.at(-1)[isQuestionNext ? FRAME_FINDER_ANSWER_KEYS.nextCoordinates : FRAME_FINDER_ANSWER_KEYS.coordinates];

            isQuestionNext ? FrameFinderUtils.checkNeededPreviousAnswers(questionCoordinates) : FrameFinderUtils.checkSelectedAnswers(questionCoordinates);

            FrameFinderUtils.setQuestionIndex(questionCoordinates, isQuestionNext);
            this.showQuestion(questionCoordinates);
        }


        /**
         * Handle the click of the "skip and view results button", get the coordinates of the alert
         * and navigate to it
         */
        handleSkip() {
            let skipAlertCoordinates = this.querySelector('#frame-finder-skip-btn').getAttribute('alert-coordinates');
            this.showQuestion(skipAlertCoordinates);
        }


        /**
         * Handle the closing of the skip questions alert, hide it and navigate to the question that was displayed
         */
        handleAlertClose() {
            this.navigateToQuestion();
        }

        /**
         * Handle the effective skip of the questions from the alert, close the alert and navigate to the last step
         * @param {string} lastStepCoordinates 
         */
        handleLastStep(lastStepCoordinates) {
            FrameFinderUtils.setQuestionIndex(lastStepCoordinates, true)
            this.showQuestion(lastStepCoordinates);
        }


        /**
         * Handle the click of the no-preference button, remove the check from all the other inputs
         */
        handleNoPreference() {
            const answersInputs = this.querySelectorAll('input[type="radio"], input[type="checkbox"]');
            answersInputs.forEach(ansInput => {
                if (!ansInput.classList.contains('no-prefinput')) {
                    ansInput.checked = false;
                }
            })
        }
    }

    customElements.define('frame-finder-main', FrameFinderMain);
}